import React from 'react';

export default function Fragile({ width, height }) {
  return (
    <svg
      width={width || '35'}
      height={height || '40'}
      viewBox="0 0 35 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3529 31.2603V30.3762L15.8438 28.7798V23.5004L15.5 23.4626C10.4402 22.9099 8.13542 19.5915 8.13542 16.7432C8.13542 13.9968 9.89601 4.58025 10.2452 2.7395H23.7541C24.1032 4.58102 25.8646 14.0083 25.8646 16.7432C25.8646 19.5907 23.5598 22.9084 18.4993 23.4626L18.1563 23.5004V28.7798L22.6471 30.3762V31.2603H11.3529Z"
        fill="#EDF9F2"
        stroke="#118842"
        strokeLinejoin="round"
      />
      <path
        d="M12.2925 15.4305L13.3385 6.01559"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M15.8438 2.7395L21.2396 7.3645L16.6146 10.4478L19.6979 12.7603L18.1563 15.8437L20.4688 19.6978"
        stroke="#118842"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}
